import React from "react";
import FeaturePageLayout from "../components/FeatureCard";

const PreviewPage = () => {
  return (
    <FeaturePageLayout
      title="Preview Before Paying"
      caption="See exactly what you’ll receive before spending a cent."
      imageUrl="DataQuality.jpg"
    />
  );
};

export default PreviewPage;
